export default "__VITE_ASSET__C_x_kC_Y__"